import React from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';

import PutLabels from '@src/api/PutLabels';
import useAxiosErrorHandler from '@src/hooks/useAxiosErrorHandler';
import useAxiosRequestConfig from '@src/hooks/useAxiosRequestConfig';
import { setLabelsFilled } from '@src/store/authentication/actions';
import { labelsSelector } from '@src/store/authentication/selectors';

const usePutLabels = () => {
  const axiosRequestConfig = useAxiosRequestConfig();
  const axiosErrorHandler = useAxiosErrorHandler();
  const data = useSelector(labelsSelector);
  const dispatch = useDispatch();

  return React.useCallback(async () => {
    try {
      if (!data) {
        return;
      }
      await PutLabels(
        {
          talents: data.talents ?? [],
          labels: data.labels ?? [],
          travellingTypePreference: data.travellingTypePreference,
        },
        axiosRequestConfig
      );
    } catch (e) {
      axiosErrorHandler(e);
    }
    dispatch(setLabelsFilled(true));
  }, [axiosErrorHandler, axiosRequestConfig, data, dispatch]);
};

export default usePutLabels;
